import { typography } from "@dsaui/components";

interface InputGroupProps {
  inline?: boolean;
  title?: string;
}

const InputGroup = ({
  children,
  title = "",
  inline = false,
}: React.PropsWithChildren<InputGroupProps>) => {
  return (
    <div className={inline ? "my-0 basis-full flex-wrap gap-2 md:flex" : "my-3"}>
      {title && <h3 className={typography.formSubtitle.className}>{title}</h3>}
      {children}
    </div>
  );
};

export default InputGroup;
